import { type FC } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { DropdownList } from '../../../Components/DropdownList/index.tsx';
import Icons from '../../../Elements/Icons/index.ts';
import { getTestId } from '../helpers.ts';
import { ToolbarItem } from '../styled.ts';
import { PlaceholdersDropdownItem } from './PlaceholdersDropdownItem.tsx';

interface PlaceholdersDropdownProps {
  placeholders: string[];
  onPlaceholderClick?: (placeholder: string) => void;
  disabled?: boolean;
  dataTestId?: string;
}

export const PlaceholdersDropdown: FC<PlaceholdersDropdownProps> = ({ placeholders, onPlaceholderClick, disabled, dataTestId }) => {
  const handlePlaceholderClick = useCallbackRef((placeholder: string) => {
    onPlaceholderClick?.(placeholder);
  });

  return (
    <DropdownList
      zIndex={1000}
      dataTestId={getTestId('toolbar-placeholders', dataTestId)}
      renderButton={(isShown) => (
        <ToolbarItem type='button' disabled={disabled} data-testid={getTestId('toolbar-placeholders', dataTestId)}>
          <Icons.More size={20} active={isShown} />
        </ToolbarItem>
      )}>
      {placeholders.map((placeholder) => (
        <PlaceholdersDropdownItem key={placeholder} item={placeholder} onClick={handlePlaceholderClick} />
      ))}
    </DropdownList>
  );
};
